import { useEffect, useId } from 'react'
import { useTabBarStore } from '../stores/tabBarStore'

export const useHideTabBar = (shouldHide: boolean, reasonKey?: string): void => {
  const autoKey = useId()
  const key = reasonKey ?? autoKey

  useEffect(() => {
    const { hide, show } = useTabBarStore.getState()
    if (shouldHide) {
      hide(key)
      return () => show(key)
    }
    show(key)
    return undefined
  }, [shouldHide, key])
}
